import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
`

export const GridContainer = styled.div`
  display: flex;
  flex: 1;
  gap: ${props => props.theme.spacing.sp8};
`
